/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../components/Modal';
import { linkWalletsScreens } from '../../screens/Card/constants';
import LinkWallets from '../../screens/Card/CardAccounts/LinkWallets';

const LinkWalletsModal = ({ hide, cryptodraftDetails }) => {
  const currentScreen = linkWalletsScreens.SELECET_WALLETS;

  const screens = useMemo(
    () => [
      {
        screen: linkWalletsScreens.SELECET_WALLETS,
        component: <LinkWallets hidePopup={hide} cryptodraftDetails={cryptodraftDetails} />,
      },
    ],
    []
  );

  const SelectedComponent = useMemo(
    () => screens.find((item) => item.screen === currentScreen).component,
    [screens, currentScreen]
  );

  return (
    <ModalRoot>
      <Modal>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{SelectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};

LinkWalletsModal.propTypes = {
  hide: PropTypes.func,
  cryptodraftDetails: PropTypes.oneOfType([PropTypes.object]),
};
LinkWalletsModal.defaultProps = {
  hide: null,
  cryptodraftDetails: null,
};

export default LinkWalletsModal;
